import { render, staticRenderFns } from "./LogworkTable.vue?vue&type=template&id=95ecb1f0&scoped=true&"
import script from "./LogworkTable.vue?vue&type=script&lang=js&"
export * from "./LogworkTable.vue?vue&type=script&lang=js&"
import style0 from "./LogworkTable.vue?vue&type=style&index=0&id=95ecb1f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ecb1f0",
  null
  
)

export default component.exports